import React, { useState } from 'react';

import { Field, Formik } from 'formik';
import * as Yup from 'yup';

import { urlRegMatch } from 'Helpers/urlService';

const AppUpdateDetailsSchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
    app_url: Yup.string().matches(urlRegMatch, $t('App Url must be a valid URL')).nullable(),
});

export default function ApiClientItemDetails(props) {
    const [request, setRequest] = useState(false);

    const deleteApp = () => {
        const message = $t('Are you sure you want to delete this app? Once deleted, it cannot be restored.');

        if (confirm(message)) {
            setRequest(true);

            axios
                .delete(props.deleteUrl)
                .then((res) => {
                    window.location.href = props.listUrl;
                })
                .catch((e) => {
                    console.log(e?.response);
                })
                .finally(() => {
                    setRequest(false);
                });
        }
    };

    return (
        <div>
            <div className="table__card">
                <div className="tw-mb-6">
                    <Formik
                        enableReinitialize
                        initialValues={{
                            name: props?.app?.name || '',
                            app_url: props?.app?.app_url || '',
                        }}
                        validationSchema={AppUpdateDetailsSchema}
                        onSubmit={(values, actions) => {
                            axios
                                .put(props.updateDetailsUrl, values)
                                .then((res) => {})
                                .catch((e) => {
                                    console.log(e?.response);
                                    props.fetchApp();
                                })
                                .finally(() => {
                                    actions.setSubmitting(false);
                                });
                        }}
                    >
                        {({ errors, touched, isSubmitting, handleSubmit }) => (
                            <>
                                <div className="tw-flex tw-flex-row tw-my-3">
                                    <label htmlFor="name" className="tw-basis-3/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                        {$t('App Name')} <span className="tw-text-red-500">*</span>
                                    </label>
                                    <div className="tw-basis-9/12">
                                        <Field
                                            type="text"
                                            className={errors.name && touched.name ? 'input text-input invalid' : 'input text-input'}
                                            placeholder={$t('App Name')}
                                            name="name"
                                        />
                                        {errors.name && touched.name && <div className="tw-text-red-500">{errors.name}</div>}
                                    </div>
                                </div>

                                <div className="tw-flex tw-flex-row tw-my-3">
                                    <label htmlFor="app_url" className="tw-basis-3/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                        {$t('App URL')}
                                    </label>
                                    <div className="tw-basis-9/12">
                                        <Field
                                            type="text"
                                            className={errors.app_url && touched.app_url ? 'input text-input invalid' : 'input text-input'}
                                            placeholder={$t('App URL')}
                                            name="app_url"
                                        />
                                        {errors.app_url && touched.app_url && <div className="tw-text-red-500">{errors.app_url}</div>}
                                    </div>
                                </div>

                                <div className="tw-flex tw-justify-end tw-mt-5">
                                    <button type="button" className={'button danger tw-mr-3'} onClick={deleteApp} disabled={request || !!isSubmitting}>
                                        {$t('Delete')}
                                    </button>

                                    <button type="button" className={'button primary'} disabled={request || !!isSubmitting} onClick={handleSubmit}>
                                        {$t('Submit')}
                                    </button>
                                </div>
                            </>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
}
